export default __webpack_public_path__ + "static/media/gluten.9d0e6e84.jpeg";